<template>
	<div :class="'avatar ' + avatarSizeClass">
		<img v-if="model.avatar"
			class="avatar-img rounded-circle"
			:src="model.avatar"/>
		<span v-else
			class="avatar-title rounded-circle">
			{{ model.initials }}
		</span>
	</div>
</template>

<script>

	export default {

		props: ['model', 'size'],

		data() {
			return {};
		},

		computed: {
			avatarSizeClass() {
				if(this.size == '') {
					return '';
				}
				return 'avatar-' + this.size;
			}
		}

	}

</script>
